export default {
  newLineTitle: 'Nova linha de fatura',
  tableActionText: 'Pressione "Adicionar" para incluir um novo item',
  title: 'Detalhes da fatura',
  confirmDeleteLine: 'Ao excluir a linha, as informações inseridas serão perdidas. Deseja excluí-la?',
  deleteLine: 'Excluir linha',
  noData: 'Não há dados disponíveis',
  headers: {
    description: 'Descrição',
    quantity: 'Quantidade',
    amount: 'Valor',
    rebate: 'Descontos/Encargos',
    taxes: 'Impostos',
    subtotal: 'Subtotal',
    type: 'Tipo',
    class: 'Classe',
    percent: '(%)',
    taxType: 'Tipo de Imposto',
    documentType: 'Tipo de Documento',
    datum: 'Dado',
    reason: 'Motivo'
  },
  form: {
    actionText: '(Artigos 14, 143 da Lei 37/1992, do IVA)',
    articleData: {
      title: 'Dados do artigo',
      vendorCode: 'Código do vendedor',
      payerCode: 'Código do pagador',
      description: 'Descrição',
      priceBatch: 'Preço por lote',
      quantity: 'Quantidade',
      unit: 'Unidade',
      batchUnits: 'Unidades por lote',
      search: 'Buscar no catálogo',
      tooltip: 'Campo obrigatório se forem enviados dados imobilizados',
      priceBatchTooltip: 'Para valores negativos, insira o número e depois o sinal de menos na frente'
    },
    resume: {
      title: 'Resumo das quantidades',
      totalBefore: 'Total antes de descontos/encargos',
      totalDiscountsCharges: 'Total descontos/encargos',
      totalTaxes: 'Total impostos',
      totalLine: 'Total linha'
    },
    discountsCharges: {
      title: 'Descontos/Encargos',
      validation: 'Os campos para o cálculo do valor não são válidos. Verifique os valores de Preço por lote, Quantidade ou Unidades por lote.'
    },
    taxes: {
      title: 'Impostos'
    },
    documents: {
      title: 'Documentos associados',
      orderSender: 'Nº do pedido do emissor',
      orderReceiver: 'Nº do pedido do receptor'
    },
    deliveryNotes: {
      title: 'Notas de entrega',
      validation: 'O campo "Dado" deve ser alfanumérico.'
    },
    extraInfo: {
      title: 'Informação adicional',
      comments: 'Observações',
      itemStartDate: 'Data de início',
      itemEndDate: 'Data de fim'
    },
    serisMandatori: 'Campos obrigatórios para faturas emitidas ao serviço de saúde de La Rioja (SERIS)'
  }
}